// extracted by mini-css-extract-plugin
module.exports = {"quotationItem":"enquireProcess_quotationItem__3G5ZE"};